import * as Sentry from '@sentry/tanstackstart-react'
import { ENV } from '@shared/constants/env'

export function initSentry() {
  if (typeof window === 'undefined' || !ENV.SENTRY_DSN || ENV.IS_DEV) {
    return
  }

  Sentry.init({
    dsn: ENV.SENTRY_DSN,
    environment: ENV.SENTRY_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

/** Sentry에 라우터 연동 (TanStack Router) */
export function initSentryRouter(
  router: Parameters<typeof Sentry.tanstackRouterBrowserTracingIntegration>[0],
) {
  if (typeof window === 'undefined' || !ENV.SENTRY_DSN) {
    return
  }

  Sentry.addIntegration(Sentry.tanstackRouterBrowserTracingIntegration(router))
}

export { Sentry }
